import { Group, Text } from "@mantine/core";
import { TestStates } from "@tsTypes/test-schema";
import clsx from "clsx";
import { Dispatch, SetStateAction } from "react";
import PlayPauseBtn from "./PlayPauseBtn";
import classes from "./TestClock.module.css";
import { getTestTimeProgressionStatus } from "./TestMetrics";

export default function TestClock({
  testStatus,
  setTestStatus,
  totalSeconds,
  currentSeconds,
}: {
  testStatus: TestStates;
  setTestStatus: Dispatch<SetStateAction<TestStates>>;
  totalSeconds: number;
  currentSeconds: number;
}) {
  const remainingSeconds = totalSeconds - currentSeconds;
  const nearEnd =
    getTestTimeProgressionStatus(currentSeconds, totalSeconds) === "nearEnd";

  return (
    <Group
      className={classes.clockWrapper}
      onClick={() => {
        if (testStatus === "taking") {
          setTestStatus("paused");
        } else if (["paused"].includes(testStatus)) {
          setTestStatus("taking");
        }
      }}
    >
      <PlayPauseBtn testStatus={testStatus} />
      <Text
        className={clsx(classes.timeDisplay, nearEnd && classes.timeDisplayNearEnd)}
      >
        {convertSecondsToMinuteClockDisplay(remainingSeconds)}
      </Text>
    </Group>
  );
}

function convertSecondsToMinuteClockDisplay(num: number) {
  const split = (num / 60).toString().split(".");
  const mins = Number(split[0]);
  const secondsFraction = Number("0." + (split[1] || "0"));
  const seconds = Math.round(secondsFraction * 60);
  return `${fixLeadingZero(mins)}:${fixLeadingZero(seconds)}`;
}

function fixLeadingZero(num: number) {
  return num < 10 ? `0${num}` : num;
}
